import { connect } from "react-redux";
import ListEntitiesComponent from "../../Components/Entities/ListEntitiesComponent";
import { setScopesNames, setRoles, setAllRoles, setScopes } from "../../Redux/Actions/ScopesActions";

const mapStateToProps = (state) => ({
  SCOPES_NAMES: state.reducer.SCOPES_NAMES,
  SCOPES: state.reducer.SCOPES,
  ACTIVE_TENANT: state.reducer.ACTIVE_TENANT, // Add this line
});

const mapDispatchToProps = (dispatch) => ({
  setScopes: (SCOPES) => dispatch(setScopes(SCOPES)),
  setScopesNames: (SCOPES_NAMES) => dispatch(setScopesNames(SCOPES_NAMES)),
  setRoles: (ROLES) => dispatch(setRoles(ROLES)),
  setAllRoles: (ROLES) => dispatch(setAllRoles(ROLES)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ListEntitiesComponent);